import { IAppState } from '../../redux';
import { selectActiveServiceId } from '../publishTerms';
import { selectStepBetByServiceId } from './selectStepBetByServiceId';

export function selectStepBet(state: IAppState): number {
  const selectedServiceId = selectActiveServiceId(state);

  if (!selectedServiceId) {
    return 1;
  }

  return selectStepBetByServiceId(selectedServiceId, state);
}
